<template>
   <div class="alibinding">
    <NavBtn
      :on-click="back"
    />
     <div class="title">更换支付宝</div>
     <div class="alipay double-row">
      <div><span class="name">支付宝账号：</span><input type="text" v-model='aliAccount'></div>
      <div><span class="name">真实姓名：</span><input type="text" v-model='realName'></div>
    </div>
    <div class="btn-middle shadow alisubmit" @click='aliSubmit()'>提交</div>
   </div>
</template>
<style lang="scss" scoped>
   .alibinding{
      background-color: #3A4E92;
      height: 100%;
      padding-top: 34px;
      .back {
        position: absolute;
        top: 16px;
        left: 20px;
        width: 40px;
        height: 40px;
        background: #342F74;
        box-shadow: 0 3px 5px 0 #36308E;
        border-radius: 50%;
      }
      .title{
        text-align: center;
        font-size: 18px;
        color: #FFFFFF;
        margin-bottom: 30px;

        @include regular();
      }
      .alipay{
        margin: 0 auto 40px;
        overflow: hidden;
        .send-code{
          float: right;
          margin-right: 15px;
          font-size: 13px;
          color: #403A92;
          text-decoration: underline;
          font-family: "PingFangSC-Regular", "-apple-system", "Helvetica Neue", "Roboto", "Segoe UI", sans-serif;
          font-weight: 400;
        }

        .name {
          font-size: 13px;
          color: #3A3A3A;

          @include regular();
        }

        input {
          font-size: 16px;
          color: #3A3A3A;
          width: 150px;
          border: none;
          outline: medium;
          background-color: transparent;

          @include semibold();
        }
      }
      .alisubmit{
        margin: 0 auto
      }
   }
</style>
<script>
import $toast from '../common/Toast.js'
import { mapState, mapActions } from 'vuex'
export default {
  data () {
    return {
      aliAccount: '',
      realName: ''
    }
  },
  // updated () {
  //   this.aliAccount = localStorage.getItem('account')
  // },
  computed: {
    ...mapState('user', [
      'info'
    ])
  },
  methods: {
    ...mapActions('user', [
      'changeAliAccount'
    ]),
    back () {
      this.$router.push('/user')
    },
    aliSubmit () {
      let account = this.aliAccount
      let realname = this.realName
      if (account !== '' || realname !== '') {
        this.changeAliAccount({
          account,
          realname
        }).then(res => {
          $toast.show(res.data.payload, '', 1000)
          this.$router.push('/user')
          // this.$cookie.set('account', this.aliAccount)
        })
      } else {
        $toast.show('请输入正确的支付宝账号', '', 2000)
      }
    }
  }
}
</script>


